import React from 'react';

import { useTranslation } from '@/i18n';
import { BodySmall } from '@/ui/typography';

export const RoomImageDisclaimer = () => {
  const { t } = useTranslation('search');
  return <BodySmall>{t('roomDisclaimer')}</BodySmall>;
};
